import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=6053b442&scoped=true&"
import script from "./icon.vue?vue&type=script&lang=js&"
export * from "./icon.vue?vue&type=script&lang=js&"
import style0 from "./icon.vue?vue&type=style&index=0&id=6053b442&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6053b442",
  null
  
)

export default component.exports